import React, { useLayoutEffect, useState } from "react";
import DynamicForm from "components/DynamicForm";
import { useNavigate, useParams } from 'react-router-dom';
import {
  Button, Col, Container, DropdownItem, DropdownMenu,
  DropdownToggle, Row, Table, UncontrolledDropdown
} from "reactstrap";
import form from 'formConfigs/addCargoMovement';
import Heading from "components/Heading";
import { errorHandler, getCounterTypeByCargoType } from "utils/Api";
import { showAlert } from "utils/Alert";
import styles from "./style.module.scss";
import { ThreeDotsVertical } from 'react-bootstrap-icons';
import SearchPackages from "components/OffCanvas/SearchPackagesOffCanvas";
import { getCargoMovement, saveCargoMovement } from "api/CargoMovementApi";
import { getTypeCounterByName } from "api/TypeCounterApi";
import { sequenceGenerator } from "utils/Form";
import { CARGO_MOVE_NOTIFICATIONS_BY_STATUS, COURIER_ADDRESS_CODE, COURIER_ADDRESS_LABEL, COURIER_TRANSPORTAION_KEY, MOVEMENT_STATUS, MOVEMENT_STATUS_CODES } from "utils/Constants";
import { getAddress } from "api/AddressApi";

const AddEditCargoMovement = props => {
  const TIPO_TRANSPORTE_FIELDNAME = "tipo_transporte";
  const STATUS_FIELDNAME = "status";
  const PACKAGE_ON_ROUTE_FILTER = {
    or: [
      { cargoMovementBoxesId: { attributeExists: false } },
      { cargoMovementBoxesId: { eq: null } },
    ]
  };

  let navigate = useNavigate();
  let { id: cargoId } = useParams();
  const [cargoData, setCargoData] = useState({});
  const [packagesList, setPackagesList] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  useLayoutEffect(() => {
    if (cargoId) {
      setIsLoading(true);
      loadCargoData(cargoId);
    }
  }, [cargoId])

  const loadCargoData = (cargoId) => {
    getCargoMovement(cargoId).then((cargoObject) => {
      setCargoData(cargoObject);
      if (cargoObject.boxes.items) {
        const packagesOnCargo = cargoObject.boxes.items.reduce((obj, box) => {
          return {
            ...obj,
            [box.id]: box
          };
        }, {});
        setPackagesList(packagesOnCargo);
      }
    }).catch((e) => console.log("fetch cargo data error", e))
      .finally(() => { setIsLoading(false) });;
  }

  const saveData = (data) => {
    setIsLoading(true);
    saveCargoMovement(data, packagesList)
      .then(async (r) => {
        showAlert("success", `Movimiento de Carga ${((data && data.id) ? "actualizado" : "creado")} exitosamente`);
        navigate("/admin/cargo-movements");
      }).catch(e => {
        errorHandler(e);
        showAlert("danger", "No fue posible guardar la informacion del Movimiento de Carga");
      }).finally((e) => {
        setIsLoading(false);
      });
  };

  const renderPackageList = () => {
    return Object.keys(packagesList).map((boxId) => {
      const box = packagesList[boxId];
      return (
        <tr key={box.id}>
          <td>
            {box.secuencia}
          </td>
          <td>
            {box.client}
          </td>
          <td>
            {box.tracking_num}
          </td>
          <td>
            {box.provedor}
          </td>
          <td>
            {rowActions(box)}
          </td>
        </tr>
      );
    });
  }

  const removeBoxFromCargo = (boxid) => {
    if (packagesList[boxid]) {
      let newPackagesList = { ...packagesList }
      delete newPackagesList[boxid];
      setPackagesList(newPackagesList);
    }
  }

  const rowActions = (box) => {
    return (
      <UncontrolledDropdown>
        <DropdownToggle tag="span" className={styles.threedotsBtn} >
          <ThreeDotsVertical size="1.5rem" />
        </DropdownToggle>
        <DropdownMenu>
          <DropdownItem header>
            Acciones
          </DropdownItem>
          <DropdownItem onClick={(e) => removeBoxFromCargo(box.id)}>
            Remover Paquete de File
          </DropdownItem>
        </DropdownMenu>
      </UncontrolledDropdown>
    );
  }

  const updateFormState = (formNewData) => {
    setCargoData(formNewData);
  }

  const onInputChange = async (fieldName, value) => {
    if (fieldName === TIPO_TRANSPORTE_FIELDNAME) {
      let sequenceNumber = "";
      if (value !== COURIER_TRANSPORTAION_KEY) {
        const sequenceType = getCounterTypeByCargoType(value);
        const counter = await getTypeCounterByName(sequenceType);
        sequenceNumber = sequenceGenerator(sequenceType, counter, true);
      }
      const newFormData = {
        ...cargoData,
        [fieldName]: value,
        secuencia: sequenceNumber
      }
      setCargoData(newFormData);
    }
    if (fieldName === STATUS_FIELDNAME && cargoData.status != value) {
      const notificationType = CARGO_MOVE_NOTIFICATIONS_BY_STATUS[value];
      if (notificationType) {
        const newPackageList = { ...packagesList };
        for (var packageId in newPackageList) {
          const packageData = newPackageList[packageId];

          let addressLabel = COURIER_ADDRESS_LABEL; 
          if (MOVEMENT_STATUS_CODES.ON_COURIER === value && COURIER_ADDRESS_CODE !== packageData.delivery_type) {
            const address = await getAddress(packageData.delivery_type)
            addressLabel = address.address || "";
          }

          const notificacionData = {
            status: MOVEMENT_STATUS[value],
            address: addressLabel
          };

          newPackageList[packageId] = {
            ...packageData,
            notificationNeeded: true,
            notificationType,
            notificacionData
          }
        }
        setPackagesList(newPackageList);
      }
    }
  }

  return (
    <>
      <Heading yellowBg={true} headingLevel="h2" className="pt-4 pb-4" label="Datos de File" sticky bordered >
        <Col sm={2}>
          <Row>
            <Col>
              <Button color="danger" onClick={(e) => { navigate("/admin/cargo-movements") }}> Cerrar</Button>
            </Col>
            <Col >
              <Button className="float-end" form="addPackage" type="submit" color="success"> Guardar</Button>
            </Col>
          </Row>
        </Col>
      </Heading>
      <Container>
        <DynamicForm
          id="addPackage"
          externalFormState={cargoData}
          useExternalState={true}
          onStateChange={updateFormState}
          onInputChange={onInputChange}
          formConfig={form}
          onSubmit={saveData}
          isLoading={isLoading}>
          <hr />
          <Heading headingLevel="h4" className="pt-2 pb-2" label="Warehouse de Embarque" >
            <Col sm={2}>
              <Row>
                <Col>
                  <SearchPackages
                    className="float-end"
                    btnColor="primary"
                    searchFilter={PACKAGE_ON_ROUTE_FILTER}
                    currentSelection={packagesList}
                    onSelect={setPackagesList}>
                    Agregar Warehouse
                  </SearchPackages>
                </Col>
              </Row>
            </Col>
          </Heading>
          <Table hover>
            <thead>
              <tr>
                <th>
                  #
                </th>
                <th>
                  Client
                </th>
                <th>
                  Tracking Number
                </th>
                <th>
                  Provedor
                </th>
                <th width="2%"></th>
              </tr>
            </thead>
            <tbody>
              {renderPackageList()}
            </tbody>
          </Table>
        </DynamicForm>
      </Container>
    </>
  );
}

export default AddEditCargoMovement;
